// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__cYrk1","cardOverlay":"Card_cardOverlay__IU3Jk"};